<script setup lang="ts">
import { ModalCollection } from '~/constants'
import Modal from '~common/modal.vue'
import { useModalWelcome } from '~/composables/event/use-modal-welcome'
import { EVENT } from '~/configs/page-url'

const { initModal, closeModalEvent } = useModalWelcome()

onMounted(() => {
  initModal()
})
</script>

<template>
  <Modal
    :modalId="ModalCollection.PREMIER_LEAGUE_RANKING"
    :isShowIconClose="false"
    modalClass="modal-welcome-popup"
    modalContentClasses="modal-welcome-popup__content"
  >
    <div>
      <div class="button-close" @click="closeModalEvent">
        <img src="/assets/images/pages/event/welcome-popup-close.webp" alt="close" />
      </div>

      <NuxtLink :to="EVENT.PREMIER_LEAGUE_RANKING" class="image-welcome" @click="closeModalEvent">
        <img src="/assets/images/pages/event/welcome-popup.webp" alt="event uefa" />
      </NuxtLink>
    </div>
  </Modal>
</template>

<style lang="scss">
@import '~scssAsset/components/common/event/welcome-popup.scss';
</style>
